
import { Component, Prop, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import LsPagination from '@/components/ls-pagination.vue'
import OrderLogistics from './order-logistics.vue'

@Component({
  components: {
    LsDialog,
    LsPagination,
    OrderLogistics
  }
})
export default class OrderPane extends Vue {
  @Prop() value: any
  @Prop() pager!: any
  
  selectIds: any = []
  
  remarks = '' //商家备注
  
  // 获取订单信息
  getOrderLists () {
    ;(this.$parent as any).getOrderLists()
  }
  
  // 选择某条数据
  selectionChange (val: any[]) {
    this.selectIds = val.map(item => item.id)
  }
  
  // 全选
  selectAll () {
    ;(this.$refs.paneTable as any).toggleAllSelection()
  }
  
  // 去订单详情
  toOrder (id: any) {
    this.$router.push({
      path: '/operating/group_welfare/purchase_order/detail',
      query: { id }
    })
  }
}
